import { Trans } from 'react-i18next';
import { throttleWait } from '@/lib/throttle-notice';

/**
 * One calm notice for a throttled request (POS-I184): "Too many attempts. Please wait N minutes and
 * try again." The minutes digits are wrapped in <bdi dir="ltr"> so they stay in order in Urdu.
 */
export function ThrottleNotice({ seconds, className }: { seconds: number; className?: string }) {
  const wait = throttleWait(seconds);
  return (
    <div
      role="alert"
      className={
        className ??
        'rounded-lg border border-destructive/30 bg-destructive/10 p-3 text-start text-sm text-destructive-text'
      }
    >
      {wait.kind === 'one' ? (
        <Trans i18nKey="throttledOneMinute" ns="auth" />
      ) : (
        <Trans
          i18nKey="throttledMinutes"
          ns="auth"
          values={{ minutes: wait.minutes }}
          components={{ bdi: <bdi dir="ltr" /> }}
        />
      )}
    </div>
  );
}
